import React, { Fragment, useContext } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Icon, cn } from '@aidkitorg/component-library';
import { PublicConfigurationContext } from '../Context';
import { useLocalizedStrings } from '../Localization';
import { portalLogout } from '../Hooks/PortalSession';

export function PortalAccountMenu() {
  const publicConfig = useContext(PublicConfigurationContext);
  const L = useLocalizedStrings();

  const logout = () => portalLogout(publicConfig);

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button
        aria-label={L.menu.logout}
        className="inline-flex items-center justify-center rounded-full p-1 text-gray-700 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-600 focus-visible:ring-offset-2"
      >
        <Icon name="UserCircleIcon" className="h-8 w-8" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-[100] mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="p-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  type="button"
                  onClick={logout}
                  className={cn(
                    'block w-full rounded-md px-4 py-2 text-left text-sm text-gray-700',
                    active && 'bg-gray-100 text-gray-900 outline-none',
                  )}
                >
                  {L.menu.logout}
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
